export default function getCID() {
    let match = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)')
    let raw = match ? decodeURIComponent(match[1]) : null
    if (!raw) return null

    match = raw.match(/(\d+\.\d+)$/)
    if (!match || !match[0]) return null

    return parseFloat(match[0])
}



// WEBPACK FOOTER //
// ./src/helpers/getCID.js